module.exports = __webpack_public_path__ + "img/rossdevise.b72439d6.png";